export default __webpack_public_path__ + "static/media/idcardgray.3685ef99.svg";